import BronzeIcon from '@/assets/images/badge/general/crown_bronze.webm';
import SilverIcon from '@/assets/images/badge/general/crown_silver.webm';
import GoldIcon from '@/assets/images/badge/general/crown_gold.webm';
import MarketSweepIcon from '@/assets/images/badge/general/market_sweep.avif';
import BronzeIconSvg from '@/assets/images/badge/general/badge_apprentice.svg';
import SilverIconSvg from '@/assets/images/badge/general/badge_rising_predictor.svg';
import GoldIconSvg from '@/assets/images/badge/general/badge_market_meister.svg';
import marketSweepIconSvg from '@/assets/images/badge/general/badge_market_sweep.avif';

import ReferralChainStar from '@/assets/images/badge/referral/badge_referral_chain_star.svg';
import ReferralChain from '@/assets/images/badge/referral/badge_referral_chain.svg';
import ReferralHandshakeStar from '@/assets/images/badge/referral/badge_referral_handshake_star.svg';
import ReferralHandshake from '@/assets/images/badge/referral/badge_referral_handshake.svg';
import ReferralShieldStar from '@/assets/images/badge/referral/badge_referral_shield_star.svg';
import ReferralShield from '@/assets/images/badge/referral/badge_referral_shield.svg';
import {
	getAchievementMetadata,
	PROBABILITY_ACHIEVEMENT_TYPES,
	UserAchievementsType,
} from '@sportspredict/shared';

export const REFERRAL_ACHIEVEMENT_TYPES = [
	UserAchievementsType.GoodFriend,
	UserAchievementsType.LinkedAvatarBorder,
	UserAchievementsType.CommunityBuilderBadge,
];

const STANDARD_ACHIEVEMENTS = {
	[UserAchievementsType.HundredTrades]: {
		icon: BronzeIcon,
		svg: BronzeIconSvg,
	},
	[UserAchievementsType.TwoHundredTrades]: {
		icon: SilverIcon,
		svg: SilverIconSvg,
	},
	[UserAchievementsType.ThousandTrades]: {
		icon: GoldIcon,
		svg: GoldIconSvg,
	},
	[UserAchievementsType.SlateWinner]: {
		icon: MarketSweepIcon,
		svg: marketSweepIconSvg,
	},
};

const REFERRAL_ACHIEVEMENTS = {
	[UserAchievementsType.GoodFriend]: {
		icon: ReferralHandshakeStar,
		svg: ReferralHandshake,
	},
	[UserAchievementsType.LinkedAvatarBorder]: {
		icon: ReferralChainStar,
		svg: ReferralChain,
	},
	[UserAchievementsType.CommunityBuilderBadge]: {
		icon: ReferralShieldStar,
		svg: ReferralShield,
	},
};

const PROBABILITY_ICONS = import.meta.glob<string>(
	'../../../../libs/shared/src/assets/badges/probability/*.avif',
	{ eager: true, import: 'default' }
);

const getProbabilityIcon = (iconSlug?: string) =>
	iconSlug &&
	Object.entries(PROBABILITY_ICONS).find(([path]) => path.endsWith(`/${iconSlug}.avif`))?.[1];

const PROBABILITY_ACHIEVEMENTS = Object.fromEntries(
	PROBABILITY_ACHIEVEMENT_TYPES.map((type) => [
		type,
		{ icon: getProbabilityIcon(getAchievementMetadata(type)?.iconSlug) },
	])
);

export const ACHIEVEMENT_COPY = {
	...Object.fromEntries(
		Object.entries(STANDARD_ACHIEVEMENTS).map(([type, config]) => [
			type,
			{
				...getAchievementMetadata(type as UserAchievementsType),
				...config,
			},
		])
	),

	...Object.fromEntries(
		Object.entries(REFERRAL_ACHIEVEMENTS).map(([type, config]) => [
			type,
			{
				...getAchievementMetadata(type as UserAchievementsType),
				...config,
				customButton: {
					text: 'View My Profile',
					redirectTo: '/profile',
				},
			},
		])
	),

	...Object.fromEntries(
		Object.entries(PROBABILITY_ACHIEVEMENTS).map(([type, config]) => [
			type,
			{
				...getAchievementMetadata(type as UserAchievementsType),
				...config,
			},
		])
	),
};
